import { CollectionTypeEnum } from "../types/Api";
/**
 * Converts a CollectionTypeEnum value to its corresponding translation key
 * @param type - The collection type enum value
 * @returns The translation key for the type, or the original value if no mapping exists
 */
export var getCollectionTypeTranslationKey = function (type) {
    var _a;
    var typeKeyMap = (_a = {},
        _a[CollectionTypeEnum.PUBLISHER_SERIES] = "ui-br-agency.collections.type.publisherSeries",
        _a[CollectionTypeEnum.SERIES] = "ui-br-agency.collections.type.series",
        _a);
    return typeKeyMap[type] || type;
};
/**
 * Translates a collection type value using the provided formatMessage function
 * @param type - The collection type enum value
 * @param formatMessage - The react-intl formatMessage function
 * @returns The translated type name, or the original value if translation fails
 */
export var translateCollectionType = function (type, formatMessage) {
    var translationKey = getCollectionTypeTranslationKey(type);
    if (translationKey.startsWith("ui-br-agency.")) {
        try {
            return formatMessage({ id: translationKey });
        }
        catch (_a) {
            return type;
        }
    }
    return type;
};
